import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import styles from "./pagePlaceholder.scss"

const PagePlaceHolder = ({brand, type, length = 0}) => (
	<div className={cx(styles.container, {
            [styles[brand]]: [styles.brand],
            [styles[`container-${type}`]]: type,
        })}>
		{Array.from({ length }).map((_, index) => (
			<div 
				// eslint-disable-next-line react/no-array-index-key
				key={index}
				className={styles.field}
                />
            ))}        
	</div>
    )

PagePlaceHolder.propTypes = {
    brand: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    length: PropTypes.number.isRequired,
};

export { PagePlaceHolder }
export default PagePlaceHolder